import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  JOB_ORDER_STATUS_ACCEPTED,
  JOB_ORDER_STATUS_ASSIGNED,
  JOB_ORDER_STATUS_CREATED,
  JOB_STATUS_CANCELLED,
  getJobTypeToActionMapping,
} from 'common/jobConstants';

import { SR_API_ACTION_JOB_ORDER_ACCEPT } from 'api/actionTypes';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

import SrLink from 'client/components/SrLink/SrLink';
import SrBox from 'client/components/SrBox';

import useDispatch from 'client/hooks/useDispatch';
import postWithState from 'client/actions/postWithState';

import './SrSunSetupDriverOrderItem.less';

const SrSunSetupDriverOrderItem = ({
  driverId,
  jobOrder,
  reloadItems,
}) => {
  const {
    id,
    dueDate,
    jobs,
    listing,
    status,
  } = jobOrder;

  const dispatch = useDispatch();

  const _handleAcceptOrder = async () => {
    await dispatch(postWithState, {
      action: SR_API_ACTION_JOB_ORDER_ACCEPT,
      payload: {
        jobOrderId: id,
        driverId,
      },
    });

    await reloadItems({
      count: 100,
      filter: {
        'jobOrders.driverId': driverId,
        'jobOrders.status': [
          JOB_ORDER_STATUS_CREATED,
          JOB_ORDER_STATUS_ASSIGNED,
          JOB_ORDER_STATUS_ACCEPTED,
        ],
      },
    });
  };

  const canAcceptOrder = status === JOB_ORDER_STATUS_ASSIGNED;
  const SrLinkOrDiv = canAcceptOrder ? 'div' : SrLink;

  return (
    <SrLinkOrDiv to={`/sunsetup/drivers/${driverId}/orders/${id}`} styleName='card'>
      <div>
        <span styleName='address'>
          {listing.addressStreetDisplay}
          <br />
          {`${listing.addressCity} ${listing.addressStateCode}, ${listing.addressZip}`}
        </span>
        <span styleName='dueDate'>
          Due Date: <span styleName='value'>{moment(dueDate).format('MMM D')}</span>
        </span>
        <div styleName='jobs'>
          {jobs.filter(({ status }) => status !== JOB_STATUS_CANCELLED).map((job) => {
            return (
              <span key={job.jobTypeId} styleName='jobType'>
                {getJobTypeToActionMapping({ job, listing })}
              </span>
            );
          })}
        </div>
        {
          canAcceptOrder && (
            <SrBox
              marginTop='24px'
            >
              <SrButton
                theme={SR_BUTTON_THEME_ADOBE_GREEN}
                onClick={_handleAcceptOrder}
              >
                Accept Order
              </SrButton>
            </SrBox>
          )
        }
      </div>
    </SrLinkOrDiv>
  );
};

SrSunSetupDriverOrderItem.propTypes = {
  driverId: PropTypes.number.isRequired,
  jobOrder: PropTypes.object.isRequired,
  reloadItems: PropTypes.func.isRequired,
};

SrSunSetupDriverOrderItem.displayName = 'SrSunSetupDriverOrderItem';

export default SrSunSetupDriverOrderItem;
